import LinkUtils from "@/utils/common/LinkUtils.ts";

/**
 * Capture mode — used while screenshotting the UI for the documentation site.
 *
 * A documentation screenshot should show the screen being documented and nothing else, but the
 * app keeps its own ambient chrome on top of it: the notifications/announcements panel that opens
 * after login, and the error/message toasts left over from whatever happened earlier. They land
 * on top of the toolbar, they differ between the Arabic and English capture of the same screen,
 * and dismissing them by hand before every shot does not scale.
 *
 * Turn it on with `?capture=1` in the URL, or at runtime from the automation helpers.
 */
export default class DocsCaptureMode {
  private static active: boolean | undefined;

  static isActive(): boolean {
    if (this.active === undefined)
      this.active = LinkUtils.getQueryParams(document.location.search)["capture"] === "1";
    return this.active;
  }

  static set(value: boolean): void {
    this.active = value;
  }
}
